import { fromPromise } from "mobx-utils";
export var fromPromise_resolve = function(value) {
    return fromPromise.resolve(value);
};
export var fromPromiseWithOldValue = function(newPromise, oldPromise) {
    return fromPromise(newPromise, /**
 * Unfortunately the fromPromise() implementation from mobx-utils only
 * uses the old value if oldPromise.state === FULFILLED.
 * https://github.com/mobxjs/mobx-utils/issues/305
 * We want to use the old value even if the oldPromise is still pending.
 * This avoids the race that happens if two requests are started in quick succession.
 */ fromPromise.resolve(oldPromise === null || oldPromise === void 0 ? void 0 : oldPromise.case({
        pending: function(stale) {
            return stale;
        },
        fulfilled: function(response) {
            return response;
        },
        rejected: function() {
            return undefined;
        }
    })));
};
